export default function StudentPosterMixin() {
    return {
        methods:{
        },
        computed:{
            nameWithGratis(){
              return `${this.gratisText} ${this.studentName}`
            },
            swedenGratis(){
              return `${this.gratisSText}`
            },
            gratisLoud(){
              return `${this.gratisText}`
            },
            studentText(){
              return `${this.studentEdit}`
            },
            studentYear(){
              return `${this.yearText}`
            },
            studentWithYear(){
              return `${this.studentText} ${this.studentYear}`
            },
        }
    }
}
